<template>
  <div>
    <!-- サイドメニュー -->
    <v-navigation-drawer v-model="drawer" class="orange lighten-2" app width="300">
      <v-container>

        <v-list-item >
            <div class="usr-name">{{ menuInfo1 }}<br/>{{ menuInfo2 }}</div>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <!-- ホーム -->
          <v-list-item @click="transScreen('ホーム')">
            <v-list-item-icon>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ホーム</v-list-item-title>
          </v-list-item>
          <!-- ユーザ -->
          <v-list-group :value="false" prepend-icon="mdi-account-circle">
            <template v-slot:activator>
              <v-list-item-title>アカウント</v-list-item-title>
            </template>
            <v-list-item v-for="menuInfo in menuUserList" :key="menuInfo.name" @click="clickMenuAction(menuInfo.name, menuInfo.link, menuInfo.newWindowFlg)">

              <v-list-item-content>
                <v-list-item-subtitle class="menu-title">{{ menuInfo.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>{{ menuInfo.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <!-- 規約 -->
          <v-list-group :value="false" prepend-icon="mdi-alpha-p-circle">
            <template v-slot:activator>
              <v-list-item-title>規約</v-list-item-title>
            </template>
            <v-list-item v-for="menuInfo in menuPolicyList" :key="menuInfo.name" @click="clickMenuAction(menuInfo.name, menuInfo.link, menuInfo.newWindowFlg)">
              <v-list-item-content>
                <v-list-item-subtitle class="menu-title">{{ menuInfo.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>{{ menuInfo.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <!-- ヘルプ -->
          <v-list-group :value="false" prepend-icon="mdi-help-circle">
            <template v-slot:activator>
              <v-list-item-title>ヘルプ</v-list-item-title>
            </template>
            <v-list-item v-for="menuInfo in menuHelpList" :key="menuInfo.name" @click="clickMenuAction(menuInfo.name, menuInfo.link)">
              <v-list-item-content>
                <v-list-item-subtitle class="menu-title">{{ menuInfo.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>{{ menuInfo.icon }}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <!-- 問い合わせ -->
          <v-list-item @click="transScreen('お問い合わせ')">
            <v-list-item-icon>
              <v-icon>mdi-email-fast-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>お問い合わせ・ご相談</v-list-item-title>
          </v-list-item>
        
          <!-- ログアウト -->
          <v-list-item @click="transScreen('ログアウト')">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ログアウト</v-list-item-title>
          </v-list-item>

          <!-- <router-link :to="{name: 'MBR600' }" >登録はこちらから</router-link> -->

        </v-list>

      </v-container>
    </v-navigation-drawer>

    <!-- グローバルナビゲーション -->
    <v-app-bar app color="#ffffff">
      <v-app-bar-nav-icon @click="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-toolbar-title>
        <div class="scn-name">{{ toolbarTitle }}</div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <div>
        <v-img src="../assets/img/touki-tqs-title.png" @click="transScreen('トップページ')"></v-img>
      </div>
    </v-app-bar>
    <!-- その他 -->
    <comMessageConfirm :msg="dlgMsgConfirm.msg" :isOpen="dlgMsgConfirm.isOpen" :doYes="dlgMsgConfirm.doYes" :doNo="dlgMsgConfirm.doNo" />
    <comMessageConfirm :msg="dlgMsgLogoutConfirm.msg" :isOpen="dlgMsgLogoutConfirm.isOpen" :doYes="dlgMsgLogoutConfirm.doYes" :doNo="dlgMsgLogoutConfirm.doNo" />
  </div>
</template>

<script>
// import Constants from '../common/constants';
export default {
  props: ["propScreenTitle", "propMenuInfo1", "propMenuInfo2", "propSrcScreenId"],
  data() {
    return {
      // menuInfo1: this.propMenuInfo1,
      // menuInfo2: this.propMenuInfo2,
      // userInfo1:"",
      // userInfo2:"",
      drawer: true,
      // menuInfoList: [
      //   { name: "ホーム", icon: "mdi-home-circle-outline", link:'/MemberHome' },
      //   { name: "アカウント設定", icon: "mdi-account-circle", link:'/ChangeAccount' },
      //   { name: "利用規約", icon: "mdi-check-decagram-outline", link:'/ServicePolicy/200/1' },
      //   { name: "ご利用ガイド", icon: "mdi-book-open-page-variant-outline", link:'/Help/100/1' },
      //   { name: "対応登記/料金", icon: "mdi-cart-variant", link:'/Help/100/2' },
      //   { name: "よくある問い合わせ", icon: "mdi-help", link:'/Help/100/0' },
      //   { name: "退会手続き", icon: "mdi-exit-run", link:'/deleteAccount' },
      //   { name: "ログアウト", icon: "mdi-logout-variant", link:'/' }
      // ],
      menuUserList: [
        { name: "アカウント設定", icon: "mdi-account-reactivate-outline", 
          link: this.$router.resolve({ name: "MBC110", params: {srcScreenId: this.propSrcScreenId} }).href, newWindowFlg: false },
        { name: "退会手続き", icon: "mdi-exit-run", 
          link: this.$router.resolve({ name: "MBC120", params: {srcScreenId: this.propSrcScreenId} }).href, newWindowFlg: false },
      ],
      menuPolicyList: [
        { name: "利用規約", icon: "mdi-check-decagram-outline", 
          link:this.$router.resolve({ name: "PSS200", params: {kbnTyp: "200", KbnCd: "0", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
        { name: "個人情報の取り扱い", icon: "mdi-account-alert-outline", 
          link:this.$router.resolve({ name: "PSS200", params: {kbnTyp: "200", KbnCd: "1", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
        { name: "特定商取引法に基づく表記", icon: "mdi-handshake-outline", 
          link:this.$router.resolve({ name: "PSS200", params: {kbnTyp: "200", KbnCd: "2", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
        { name: "会社情報", icon: "mdi-domain", 
          link:this.$router.resolve({ name: "PSS200", params: {kbnTyp: "200", KbnCd: "3", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
      ],
      menuHelpList: [
        { name: "よくある問い合わせ", icon: "mdi-chat-question-outline", 
          link:this.$router.resolve({ name: "PSS300", params: {kbnTyp: "100", KbnCd: "0", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
        { name: "ご利用ガイド", icon: "mdi-book-open-page-variant-outline", 
          link:this.$router.resolve({ name: "PSS300", params: {kbnTyp: "100", KbnCd: "1", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
        { name: "対応登記/料金", icon: "mdi-currency-jpy", 
          link:this.$router.resolve({ name: "PSS300", params: {kbnTyp: "100", KbnCd: "2", srcScreenId: "MBR100"} }).href, newWindowFlg: true },
      ],
      transViewPath: "",
      dlgMsgConfirm: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.clearStoreForEditStartOutMixin();
          // 次画面遷移
          this.$router.push(this.transViewPath);
        },
        doNo: () => {
          this.dlgMsgConfirm.isOpen = false;
        },
      },
      dlgMsgLogoutConfirm: {
        msg: "",
        isOpen: false,
        doYes: () => {
          // 編集状態初期化
          this.clearStoreForLogOutMixin();
          // 次画面遷移
          this.$router.push(this.transViewPath);
        },
        doNo: () => {
          this.dlgMsgLogoutConfirm.isOpen = false;
        },
      },
    }
  },
  computed: {
    toolbarTitle() {
      return this.propScreenTitle;
    },
    menuInfo1() {
      return this.propMenuInfo1;
    },
    menuInfo2() {
      return this.propMenuInfo2;
    },
    sourceScreenUrl() {
      return this.propSrcScreenId;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
   /*
    * 初期表示
    */
    initialize: function () {
      // let userInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
      // if (userInfo != null) {
      //   this.propMenuInfo1 = userInfo['name'];
      //   this.propMenuInfo2 = userInfo['companyname'];
      // }
      let bp =this.$vuetify.breakpoint.name;
      if (bp == 'xs' ) {
        this.drawer = false;
      } else {
        this.drawer = true;
      }
    },

    transScreen: function(name) {
      // 遷移先
      if (name == 'ログアウト' || name == 'トップページ') {  
        this.transViewPath = this.$router.resolve({ name: "PSS100" }).href;
      } else if (name == 'ホーム') {
        this.transViewPath = this.$router.resolve({ name: "MBR100" }).href;
      } else if (name == 'お問い合わせ') {
        this.transViewPath = this.$router.resolve({ name: "PSS400", params: {srcScreenId: "MBR100"} }).href;
        // this.transViewPath = this.$router.resolve({ name: "MBR600" }).href;
      }
      if (name == 'ログアウト' || name == 'トップページ') {
        // 確認メッセージ表示
        this.dlgMsgLogoutConfirm.msg = this.$i18n.t('msg.wrn.ps010');
        this.dlgMsgLogoutConfirm.isOpen = true;
      } else {
        // 編集状態
        let status = this.$store.getters["requestRegInfo/getEditStatus"];
        if (status == "1" || status == "2") {
          // 編集中の場合
          // 確認メッセージ表示
          this.dlgMsgConfirm.msg = this.$i18n.t('msg.wrn.ps011');
          this.dlgMsgConfirm.isOpen = true;
        } else {
          this.clearStoreForEditStartOutMixin();
          // if (name == 'お問い合わせ') {
          //   window.open(this.transViewPath, '_blank', 'noreferrer');
          // } else{
          //   // 遷移
          //   this.$router.push(this.transViewPath).catch(()=>{});
          // }
          // 遷移
          this.$router.push(this.transViewPath).catch(()=>{});          
          
        }
      }
    },

    /**
     * メニュー押下
     */
    clickMenuAction(name, action) {
      // 遷移先URL
      this.transViewPath = action;
      // // if (newWindowFlg) {
      // if (name != 'アカウント設定' || name != '退会手続き') {
      //   // 利用規約, ヘルプ
      //   // window.open(action, '_blank', 'noreferrer');
      //   // 遷移
      //   this.$router.push(action).catch(()=>{});
      // } else {
      //   // アカウント設定, その他
      //   // 編集状態
      //   let status = this.$store.getters["requestRegInfo/getEditStatus"];
      //   if (status == "1" || status == "2") {
      //     // 編集中の場合
      //     // 確認メッセージ表示
      //     this.dlgMsgConfirm.msg = this.$i18n.t('msg.wrn.ps011');
      //     this.dlgMsgConfirm.isOpen = true;
      //   } else {
      //     this.clearStoreForEditStartOutMixin();
      //     // 遷移
      //     this.$router.push(action).catch(()=>{});
      //   }
      // }
      let status = this.$store.getters["requestRegInfo/getEditStatus"];
      if (status == "1" || status == "2") {
        // 編集中の場合
        // 確認メッセージ表示
        this.dlgMsgConfirm.msg = this.$i18n.t('msg.wrn.ps011');
        this.dlgMsgConfirm.isOpen = true;
      } else {
        this.clearStoreForEditStartOutMixin();
        // 遷移
        this.$router.push(action).catch(()=>{});
      }
    }
  },
};
</script>

<style scoped>
.scn-name {
  font-size: x-large;
  color: #f17a35;
}
.usr-name {
 font-size: medium;
  color: #000000;
}
.menu-title {
  font-size: 0.8em !important;
  color: #000000;
}

@media screen and (max-width: 750px) {
  .scn-name {
    font-size: medium;
  }
}
</style>